import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import styles from "./BaseSelectButton.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

type ViewOption = {
  id: string | number;
  label: string;
  icon: React.ComponentType<{ size?: number }>;
};

type BaseSelectButtonProps = {
  viewOptions?: ViewOption[];
  selectedView: string | number;
  onViewChange: (viewId: string | number) => void;
  className?: string;
};

const BaseSelectButton: React.FC<BaseSelectButtonProps> = ({
  viewOptions = [],
  selectedView,
  onViewChange,
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const currentView = viewOptions.find((view) => view.id === selectedView);
  const CurrentIcon = currentView?.icon;

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const selectView = (viewId: string | number) => {
    onViewChange(viewId);
    setIsOpen(false);
  };

  if (!currentView || !CurrentIcon) {
    return null;
  }

  return (
    <div className={cx("container", className)}>
      <button onClick={toggleDropdown} className={cx("main-button")}>
        <ChevronDown
          size={12}
          className={cx("chevron", { "chevron-open": isOpen })}
        />
        <span>{currentView.label}</span>
      </button>
      {isOpen && (
        <>
          <div
            className={cx("dropdown-backdrop")}
            onClick={() => setIsOpen(false)}
          />
          <div className={cx("dropdown")}>
            {viewOptions.map((option) => {
              const isSelected = option.id === selectedView;
              return (
                <button
                  key={option.id}
                  onClick={() => selectView(option.id)}
                  className={cx("dropdown-item", { selected: isSelected })}
                >
                  <span>{option.label}</span>
                  {isSelected && <div className={cx("selected-dot")} />}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default BaseSelectButton;
